<template>
	<div :class="$style.editor">
		<editor-content
			v-focus
			:class="$style.editorContent"
			:editor="editor"
		/>
		<div
			v-if="mandatory"
			:class="$style.editorReadOnlyContent"
			v-html="mandatoryHtml"
		/>

		<editor-menu-bubble
			v-slot="{ commands, isActive, menu }"
			:editor="editor"
			:keep-in-bounds="keepInBounds"
			:style="{ 'z-index': 1099 }"
		>
			<div
				class="menububble"
				:class="{ [$style.isActive]: menu.isActive, [$style.editorMenuBubble]: true }"
				:style="`left: ${menu.left}px; bottom: ${menu.bottom}px;`"
			>
				<a-tooltip placement="top">
					<template slot="title">
						<fa-icon :icon="['fa', 'bold']" /> Negrita
					</template>

					<a-button
						type="link"
						:class="{ [$style.isActive]: isActive.bold() }"
						@click="commands.bold"
					>
						<fa-icon :icon="['fa', 'bold']" />
					</a-button>
				</a-tooltip>

				<a-tooltip placement="top">
					<template slot="title">
						<fa-icon :icon="['fa', 'italic']" /> Cursiva
					</template>

					<a-button
						type="link"
						:class="{ [$style.isActive]: isActive.italic() }"
						@click="commands.italic"
					>
						<fa-icon :icon="['fa', 'italic']" />
					</a-button>
				</a-tooltip>

				<a-tooltip placement="top">
					<template slot="title">
						<fa-icon :icon="['fa', 'strikethrough']" /> Subrayado
					</template>

					<a-button
						type="link"
						:class="{ [$style.isActive]: isActive.underline() }"
						@click="commands.underline"
					>
						<fa-icon :icon="['fa', 'strikethrough']" />
					</a-button>
				</a-tooltip>

				<a-tooltip placement="top">
					<template slot="title">
						<fa-icon :icon="['fa', 'highlighter']" /> Destacado
					</template>

					<a-button
						type="link"
						:class="{ [$style.isActive]: isActive.code() }"
						@click="commands.code"
					>
						<fa-icon :icon="['fa', 'highlighter']" />
					</a-button>
				</a-tooltip>
			</div>
		</editor-menu-bubble>

		<editor-menu-bar
			v-slot="{ commands, isActive }"
			:editor="editor"
			:class="$style.editorMenu"
		>
			<div class="d-flex">
				<a-tooltip :placement="helpPosition">
					<template slot="title">
						<fa-icon :icon="['fa', 'bold']" /> Negrita
					</template>

					<a-button
						type="link"
						:class="{ [$style.isActive]: isActive.bold() }"
						@click="commands.bold"
					>
						<fa-icon :icon="['fa', 'bold']" />
					</a-button>
				</a-tooltip>

				<a-tooltip :placement="helpPosition">
					<template slot="title">
						<fa-icon :icon="['fa', 'italic']" /> Cursiva
					</template>

					<a-button
						type="link"
						:class="{ [$style.isActive]: isActive.italic() }"
						@click="commands.italic"
					>
						<fa-icon :icon="['fa', 'italic']" />
					</a-button>
				</a-tooltip>

				<a-tooltip :placement="helpPosition">
					<template slot="title">
						<fa-icon :icon="['fa', 'strikethrough']" /> Subrayado
					</template>

					<a-button
						type="link"
						:class="{ [$style.isActive]: isActive.underline() }"
						@click="commands.underline"
					>
						<fa-icon :icon="['fa', 'strikethrough']" />
					</a-button>
				</a-tooltip>

				<a-tooltip :placement="helpPosition">
					<template slot="title">
						<fa-icon :icon="['fa', 'highlighter']" /> Destacado
					</template>

					<a-button
						type="link"
						:class="{ [$style.isActive]: isActive.code() }"
						@click="commands.code"
					>
						<fa-icon :icon="['fa', 'highlighter']" />
					</a-button>
				</a-tooltip>

				<a-tooltip :placement="helpPosition">
					<template slot="title">
						<fa-icon :icon="['fa', 'paragraph']" /> Párrafo
					</template>

					<a-button
						type="link"
						:class="{ [$style.isActive]: isActive.paragraph() }"
						@click="commands.paragraph"
					>
						<fa-icon :icon="['fa', 'paragraph']" />
					</a-button>
				</a-tooltip>

				<a-tooltip :placement="helpPosition">
					<template slot="title">
						Título 1
					</template>

					<a-button
						type="link"
						:class="{ [$style.isActive]: isActive.heading({ level: 1 }) }"
						@click="commands.heading({ level: 1 })"
					>
						H1
					</a-button>
				</a-tooltip>

				<a-tooltip :placement="helpPosition">
					<template slot="title">
						Título 2
					</template>

					<a-button
						type="link"
						:class="{ [$style.isActive]: isActive.heading({ level: 2 }) }"
						@click="commands.heading({ level: 2 })"
					>
						H2
					</a-button>
				</a-tooltip>

				<a-tooltip :placement="helpPosition">
					<template slot="title">
						Título 3
					</template>

					<a-button
						type="link"
						:class="{ [$style.isActive]: isActive.heading({ level: 3 }) }"
						@click="commands.heading({ level: 3 })"
					>
						H3
					</a-button>
				</a-tooltip>

				<a-tooltip :placement="helpPosition">
					<template slot="title">
						<fa-icon :icon="['fa', 'list-ul']" /> Lista (ord)
					</template>

					<a-button
						type="link"
						:class="{ [$style.isActive]: isActive.bullet_list() }"
						@click="commands.bullet_list"
					>
						<fa-icon :icon="['fa', 'list-ul']" />
					</a-button>
				</a-tooltip>

				<a-tooltip :placement="helpPosition">
					<template slot="title">
						<fa-icon :icon="['fa', 'list-ol']" /> Lista (num)
					</template>

					<a-button
						type="link"
						:class="{ [$style.isActive]: isActive.ordered_list() }"
						@click="commands.ordered_list"
					>
						<fa-icon :icon="['fa', 'list-ol']" />
					</a-button>
				</a-tooltip>

				<a-tooltip :placement="helpPosition">
					<template slot="title">
						<fa-icon :icon="['fa', 'quote-right']" /> Cita
					</template>

					<a-button
						type="link"
						:class="{ [$style.isActive]: isActive.blockquote() }"
						@click="commands.blockquote"
					>
						<fa-icon :icon="['fa', 'quote-right']" />
					</a-button>
				</a-tooltip>

				<a-tooltip :placement="helpPosition">
					<template slot="title">
						<fa-icon :icon="['fa', 'code']" /> Código
					</template>

					<a-button
						type="link"
						:class="{ [$style.isActive]: isActive.code_block() }"
						@click="commands.code_block"
					>
						<fa-icon :icon="['fa', 'code']" />
					</a-button>
				</a-tooltip>

				<a-tooltip :placement="helpPosition">
					<template slot="title">
						<fa-icon :icon="['fa', 'arrows-alt-h']" /> Divisor
					</template>

					<a-button
						type="link"
						@click="commands.horizontal_rule"
					>
						<fa-icon :icon="['fa', 'arrows-alt-h']" />
					</a-button>
				</a-tooltip>

				<div class="ml-auto" />

				<a-tooltip :placement="helpPosition">
					<template slot="title">
						<fa-icon :icon="['fa', 'undo']" /> Deshacer
					</template>

					<a-button
						type="link"
						@click="commands.undo"
					>
						<fa-icon :icon="['fa', 'undo']" />
					</a-button>
				</a-tooltip>

				<a-tooltip :placement="helpPosition">
					<template slot="title">
						<fa-icon :icon="['fa', 'redo']" /> Rehacer
					</template>

					<a-button
						type="link"
						@click="commands.redo"
					>
						<fa-icon :icon="['fa', 'redo']" />
					</a-button>
				</a-tooltip>
			</div>
		</editor-menu-bar>
	</div>
</template>

<script>
import { Editor, EditorContent, EditorMenuBar, EditorMenuBubble } from 'tiptap';
import sanitizeHtml from 'sanitize-html';

import { Blockquote, CodeBlock, HardBreak, Heading, OrderedList, BulletList, ListItem, TodoItem, TodoList, Bold, Code, Italic, Link, Strike, Underline, History, HorizontalRule } from 'tiptap-extensions';

export default {
	name: 'GEditor',
	components: {
		EditorContent,
		EditorMenuBar,
		EditorMenuBubble
	},
	props: {
		value: {
			type: String,
			default: ''
		},
		menu: {
			type: Boolean,
			default: true
		},
		floatMenu: {
			type: Boolean,
			default: true
		},
		helpPosition: {
			type: String,
			default: 'bottom'
		},
		mandatory: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			keepInBounds: true,
			editor: null,
			editorReadOnly: null,
			html: ''
		};
	},
	computed: {
		mandatoryHtml() {
			if (this.mandatory) {
				return sanitizeHtml(this.mandatory, {
					allowedTags: ['a', 'b', 'i', 'em', 'pre', 'code', 'strong', 'br', 'div', 'center'],
					allowedAttributes: {
						a: ['href', 'title', 'style']
					}
				});
			}
			return '';
		}
	},
	created() {
		this.html = this.value;
	},
	mounted() {
		this.editor = new Editor({
			extensions: [
				new Blockquote(), new CodeBlock(), new HardBreak(), new Heading({ levels: [1, 2, 3] }),
				new BulletList(), new OrderedList(), new ListItem(), new TodoItem(), new TodoList(),
				new Bold(), new Code(), new Italic(), new Link(), new Strike(),
				new Underline(), new History(), new HorizontalRule()
			],
			content: this.html,
			onUpdate: ({ getHTML }) => {
				this.html = getHTML();
				this.$emit('input', this.html);
			}
		});

		this.$emit('input', this.html);
	},
	beforeDestroy() {
		this.editor.destroy();
	}
};
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
